export default "__VITE_ASSET__66880571__"